import {
  afterRenderEffect,
  Component,
  computed,
  ElementRef,
  inject,
  viewChild,
} from '@angular/core';
import { isFlutterWebView } from '../services/flutter-webview';
import { ResponsiveService } from '../services/responsive';
import { V3ChatService } from '../services/v3-chat';

// Web entry point below the header: sparkle circle + prompt card, one button. See CLAUDE.md here.
@Component({
  selector: 'app-v3-chat-card',
  standalone: true,
  templateUrl: './v3-chat-card.html',
  styleUrl: './v3-chat-card.scss',
})
export class V3ChatCard {
  readonly chat = inject(V3ChatService);
  private readonly responsive = inject(ResponsiveService);
  private readonly flutter = isFlutterWebView();

  readonly visible = computed(() => this.chat.isAvailable() && !this.flutter);
  readonly isDesktop = computed(() => !this.responsive.isMobile());

  private readonly entry = viewChild<ElementRef<HTMLElement>>('entry');
  private readonly card = viewChild<ElementRef<HTMLElement>>('card');

  constructor() {
    // The circle is as wide as the card is tall — CSS can't express that across browsers, so measure.
    afterRenderEffect((onCleanup) => {
      const entry = this.entry()?.nativeElement;
      const card = this.card()?.nativeElement;
      if (!entry || !card) return;
      const sync = () => entry.style.setProperty('--v3-chat-card-height', `${card.offsetHeight}px`);
      sync();
      const observer = new ResizeObserver(sync);
      observer.observe(card);
      onCleanup(() => observer.disconnect());
    });
  }

  open(event: Event): void {
    this.chat.open(event.currentTarget as HTMLElement);
  }
}
